import { Box, Separator } from "@chakra-ui/react";
import AdvantageCardList from "@/components/advantageCard";
import { LBGhoverEffect } from "styles/hoverPresets";
import { ADVANTAGES_CONSTANTS } from "./constants";

const AdvantageComp = () => {
  return (
    <Box>
      <AdvantageCardList
        items={ADVANTAGES_CONSTANTS}
        hoverEffect
        hover={LBGhoverEffect}
      />
      <Separator borderWidth="2px" borderColor="#ECECEC" mt={4} />
    </Box>
  );
};

export default AdvantageComp;
